export default [
  {
    path: '/admin/holiday-rules',
    name: 'holiday-rule',
    meta: { requiresAuth: true },
    component: () => import('@/pages/human-resource/holiday-rule')
  }
]
